
import { extname } from 'path';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faFolderOpen)

import * as React from 'react';

import { TemplateHolder } from '../logic';

import FileDrop from '../FileDrop';
import { MimeType } from '../logic/mimeTypes';
import { ITemplate, TEMPLATE_DROPZONES } from '../logic/templates';
// import Popup from '../Popup';
import TemplateEntry from '../TemplateEntry';

import './style.css';

interface ITemplatesProps {
  single?: boolean;
  name?: string;
  noRender?: boolean;
  header?: string;
  supportedTypes?: string;
}
interface ITemplatesState {
  draggingOver?: boolean;
  // invalid?: boolean;
}
class Templates extends React.Component<ITemplatesProps, ITemplatesState> {
  protected holder = new TemplateHolder();
  protected listeners: Array<((templates: this) => void)> = [];
  constructor(props: any, context: any) {
    super(props, context);
    this.state = { draggingOver: false };
    this.holder.onChanged = () => this.fireOnChange();
    this.fileAdded = this.fileAdded.bind(this);
  }
  public onChange(listener: (templates: this) => void) {
    this.listeners.push(listener);
  }
  public getTemplates() {
    return [...this.holder.templates];
  }
  public setTemplates(templates: ITemplate[]) {
    this.holder.templates = [...templates];
    this.fireOnChange();
  }
  public clear() {
    this.setTemplates([]);
  }
  public removeTemplate(template: ITemplate) {
    this.holder.remove(template.filename);
    this.fireOnChange();
  }
  public addTemplate(template: ITemplate) {
    if (this.props.single) this.holder.clear();
    this.holder.add(template);
    this.fireOnChange();
  }
  public addInferredTemplate(filename: string, buffer: ArrayBuffer, mimeType?: MimeType) {
    const ext = extname(filename).substr(1);
    if (!mimeType && ext) mimeType = MimeType[ext];
    mimeType = mimeType || '' as MimeType;
    // const bufferString = String.fromCharCode.apply(null, new Uint8Array(buffer));
    // try {
    //   JSON.parse(bufferString);
    //   console.log("True for correct json");
    //   // this.state = { invalid: false }
    //   // alert("Correct JSON");
    // } catch (e) {
    //   console.log("false for incorrect json");
    //   // this.state = { invalid: true };
    //   // alert("Invalid JSON File \n " + e.name + " : " + e.message);
    // }

    this.addTemplate({ filename, buffer, mimeType });
  }
  public fileAdded(files: FileList, event: React.DragEvent<HTMLDivElement>) {
    this.dragLeave();
    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        this.addInferredTemplate(file.name, reader.result as ArrayBuffer, file.type as any as MimeType);
      }
      console.log(reader.result as ArrayBuffer);
      reader.readAsArrayBuffer(file);
    });
    const items = event.dataTransfer.items;
    if (!items) return; // No getAsEntry stuff, can't handle directories
    for (let i = 0; i < items.length; i++) {
      const item = items.item ? items.item(i) : items[i];
      if (!item || !item.webkitGetAsEntry) continue;
      const entry = item.webkitGetAsEntry();
      if (!entry || !entry.isDirectory) continue;
      try {
        this.loadWebkitEntry(entry);
      } catch (e) {
        console.log('Something went wrong while loading a directory:', e);
      }
    }
  }
  public loadWebkitEntry(entry: any) {
    if (entry.isFile) {
      entry.file((file: File) => {
        let filename = entry.fullPath;
        if (filename.startsWith('/')) {
          filename = filename.match(/^\/[^\/]+\/(.+)$/)[1];
        }
        const reader = new FileReader();
        reader.onload = () => this.addInferredTemplate(filename, reader.result as ArrayBuffer, file.type as any as MimeType);
        reader.readAsArrayBuffer(file);
      });
    } else if (entry.isDirectory) {
      entry.createReader().readEntries((entries: any) => entries.forEach(this.loadWebkitEntry, this));
    }
  }
  public componentDidMount() {
    TEMPLATE_DROPZONES.push(this);
  }
  public componentWillUnmount() {
    const index = TEMPLATE_DROPZONES.indexOf(this);
    if (index === -1) return;
    TEMPLATE_DROPZONES.splice(index, 1);
  }
  public render() {
    let unnamed = 0;
    return (
      <div className={this.state.draggingOver ? 'Templates draggingOver' : 'Templates'}>
        {this.props.children}
        {this.props.header && <h4>{this.props.header}</h4>}
        {!this.props.noRender && (
          <ul>
            {this.holder.templates.map(f =>
              <TemplateEntry
                key={f.filename || `<Unnamed ${++unnamed}>`}
                template={f}
                holder={this.holder} />)}
          </ul>
        )}
        <FileDrop
          onDrop={this.fileAdded}
          onDragOver={this.dragOver}
          onDragLeave={this.dragLeave} >
          <FontAwesomeIcon icon="folder-open" /> Drop your {this.props.name || 'files'} here
          <div className="small">{(this.props.supportedTypes ? `Supported file types: ${this.props.supportedTypes}` : '')}</div>
        </FileDrop>
        {/* <Popup visible={this.state.invalid === true} close={this.closePopup}>
          Invalid JSON
        </Popup> */}
      </div>
    );
  }
  public dragOver = () => this.setState({ draggingOver: true });
  public dragLeave = () => this.setState({ draggingOver: false });
  // protected closePopup = () => {
  //   this.setState({});
  // };
  protected fireOnChange() {
    this.listeners.forEach(listener => listener(this));
    this.forceUpdate();
  }
}

export default Templates;



// WEBPACK FOOTER //
// ./src/Templates/index.tsx